export default __webpack_public_path__ + "static/media/bell.6976a02f.mp3";